








import { Component, Prop, Vue } from "vue-property-decorator";
import { ImagePreview, Popup, Swipe, SwipeItem, Loading } from "vant";
Vue.use(ImagePreview);
@Component({
  components: {
    "van-popup": Popup,
    "van-swipe": Swipe,
    "van-swipe-item": SwipeItem,
    "van-loading": Loading
  }
})
export default class ImageViewMu extends Vue {
  @Prop()
  appId!: string | number;
  @Prop()
  ImgSrcArr!: any;
  @Prop()
  showmore!: any;
  @Prop()
  sty!: any;

  Imgindex: number = 0;

  viewIndex: number = 0;
  showBtn = false;
  showLoad = false;

  IndexArr: Array<Number> = [];
  onChange(index: number) {
    this.viewIndex = index;
    console.log(this.IndexArr.indexOf(index));
    if (this.IndexArr.indexOf(index) < 0) {
      this.showBtn = true;
    } else {
      this.showBtn = false;
    }
  }
  onClose() {
    this.showBtn = false;
    this.showLoad = false;
  }
  openView(index: number) {
    console.log(this.showmore);
    console.log(this.ImgSrcArr.length);
    this.Imgindex = index;
    if (this.IndexArr.indexOf(index) < 0) {
      this.showBtn = true;
    } else {
      this.showBtn = false;
    }
    this.viewIndex = this.Imgindex;
    if (this.showmore && index != 0 && this.ImgSrcArr.length == index) {
      this.showBtn = false;
    }
  }

  // 查看原图
  viewPic() {
    const elements: Array<HTMLElement> = Array.prototype.slice.call(
      document.querySelectorAll(".van-swipe-item .img") as NodeListOf<
        HTMLElement
      >,
      0
    );
    const src = elements[this.viewIndex].getElementsByTagName("img")[0];
    src.getAttribute("src") as string;
    const newSrc = (src.getAttribute("src") as string).split("?")[0];
    if (newSrc) {
      this.showLoad = true;
      console.log(newSrc);
      src.setAttribute("src", newSrc);
      this.showBtn = false;

      this.IndexArr.push(this.viewIndex);
      src.onload = () => {
        this.showLoad = false;
      };
    }
  }
}
